export default {
    ca: {
        month: {
            month0: 'gen',
            month1: 'feb',
            month2: 'mar',
            month3: 'abr',
            month4: 'maig',
            month5: 'jun',
            month6: 'jul',
            month7: 'ago',
            month8: 'sep',
            month9: 'oct',
            month10: 'nov',
            month11: 'dec',
        },
    },
    es: {
        month: {
            month0: 'ene',
            month1: 'feb',
            month2: 'mar',
            month3: 'abr',
            month4: 'may',
            month5: 'jun',
            month6: 'jul',
            month7: 'ago',
            month8: 'sep',
            month9: 'oct',
            month10: 'nov',
            month11: 'dec',
        },
    },
    en: {
        month: {
            month0: 'jan',
            month1: 'feb',
            month2: 'mar',
            month3: 'apr',
            month4: 'may',
            month5: 'jun',
            month6: 'jul',
            month7: 'aug',
            month8: 'sep',
            month9: 'oct',
            month10: 'nov',
            month11: 'dec',
        },
    },
};



// WEBPACK FOOTER //
// ./src/shared/translations/months.js